var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3254 10.6139C22.6344 8.92931 20.385 8.00096 17.9909 8C15.6022 8 13.3492 8.92752 11.6472 10.6117C9.94208 12.2988 9.0022 14.5408 9 16.9166V16.9194V16.921C9.00027 18.359 9.37807 19.8096 10.0952 21.1337L9.02458 26L13.9469 24.8804C15.1935 25.5086 16.5845 25.8399 17.9875 25.8404H17.9911C20.3794 25.8404 22.6324 24.9128 24.3347 23.2284C26.0413 21.54 26.9816 19.3008 26.9827 16.9235C26.9834 14.563 26.0398 12.3222 24.3254 10.6139ZM17.9909 24.4355H17.9878C16.7281 24.435 15.4799 24.1187 14.3784 23.5207L14.1456 23.3943L10.8725 24.1388L11.5834 20.9077L11.4464 20.6714C10.765 19.4962 10.4049 18.199 10.4049 16.9195C10.4075 12.7781 13.8102 9.40488 17.9907 9.40488C20.0102 9.4057 21.9078 10.1886 23.3339 11.6091C24.7814 13.0517 25.5784 14.9388 25.5777 16.9231C25.576 21.0655 22.1726 24.4355 17.9909 24.4355Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5444 12.9873H15.1503C15.0131 12.9873 14.7903 13.0387 14.6019 13.2437C14.4134 13.4489 13.882 13.9448 13.882 14.9533C13.882 15.9619 14.6191 16.9363 14.7218 17.0733C14.8247 17.21 16.1445 19.3458 18.235 20.1674C19.9723 20.8502 20.3259 20.7144 20.7029 20.6802C21.08 20.6461 21.9198 20.1844 22.0912 19.7059C22.2626 19.2273 22.2626 18.8169 22.2112 18.7312C22.1597 18.6458 22.0225 18.5946 21.8169 18.4921C21.6112 18.3896 20.6032 17.8853 20.4147 17.8168C20.2261 17.7485 20.0891 17.7143 19.9519 17.9196C19.8147 18.1245 19.4108 18.5986 19.2908 18.7354C19.1709 18.8723 19.0508 18.8894 18.8451 18.7868C18.6394 18.684 17.9838 18.4637 17.1981 17.7655C16.5866 17.2221 16.1623 16.5292 16.0422 16.324C15.9223 16.119 16.0295 16.008 16.1326 15.9057C16.225 15.8139 16.3499 15.6884 16.4527 15.5688C16.5554 15.4491 16.5847 15.3636 16.6534 15.2269C16.7219 15.0901 16.6875 14.9703 16.6362 14.8679C16.5847 14.7653 16.19 13.7517 16.0071 13.3463H16.0072C15.8531 13.0049 15.6909 12.9933 15.5444 12.9873Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.f9c404cec129d487b3a828fa15b9df84.svg";
export { ForwardRef as ReactComponent };